const AdjustItemHeader = ({ Texts }: { Texts: { [key: string]: string } }) => {
  return (
    <section className="flex justify-between bg-[#D9D9D9] text-13">
      <div className="w-[11%] p-2 font-semibold text-black">{Texts.date}</div>
      <div className="w-[36%] p-2 font-semibold text-black">{Texts.item_Description}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.qty}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.Status}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.itemPrice}</div>
      <div className="w-1/6 p-2 font-semibold text-black">{Texts.totalPrice}</div>
    </section>
  );
};

export default AdjustItemHeader;
